import { pollingBegin, pollingFailure, pollingStart } from './polling'
import { initializeAuthentication } from './authentication'

export const getSignedUrl = (file, source) => (dispatch, getState, { api }) => {
  const options = {
    source,
    filename: file.name,
  }
  return api
    .getUploadPolicy(options)
    .then(data => {
      const { authentication } = data
      // in widget, user creation is a "side effect" of document upload
      if (authentication && authentication.user && authentication.session) {
        dispatch(initializeAuthentication(authentication.user, authentication.session))
      }
      return data
    })
    .then(data => Promise.resolve(Object.assign(data, { source, filename: file.name })))
}

export const ActionTypes = {
  DOCUMENT_DELETE_REQUEST: 'DOCUMENT_DELETE_REQUEST',
  DOCUMENT_DELETE_SUCCESS: 'DOCUMENT_DELETE_SUCCESS',
  SET_DOCUMENT_UPLOAD_START_TIME: 'SET_DOCUMENT_UPLOAD_START_TIME',
}

export const setDocUploadStartTime = () => ({
  type: ActionTypes.SET_DOCUMENT_UPLOAD_START_TIME,
  startTime: Date.now(),
})

export const onSuccessFactory = config => {
  const onUploadSuccess = config.getOnUploadSuccess()
  if (onUploadSuccess) {
    // If passed in as a prop, call this rather
    //  than redirect.
    return onUploadSuccess
  }

  const successRedirect = document => {
    const redirectUrl = `${config.wptAppUrl}/edit/${document.id}/?token=${config.getToken()}&runChecks=true`
    window.location.assign(redirectUrl)
  }
  return successRedirect
}

export const createDocument = (data, uploadStartTime) => (dispatch, getState, { api, config }) => {
  // for file upload (ReactS3Uploader), reference to uploadStartTime was set in component initialization -- ie to null
  //  several attempts to reset the value -- the simplest solution is to set in store
  const uploadTime = Date.now() - (uploadStartTime || getState().documents.uploadStartTime)
  const dataWithTime = Object.assign({ uploadTime }, data)

  api.createDocument(dataWithTime).then(
    upload =>
      dispatch(
        pollingStart({
          jobId: upload.id,
          startFunction: () => Promise.resolve(upload),
          getResultFunction: () => api.loadDocument(upload.id),
          onSuccess: onSuccessFactory(config),
          onFailure: error => {
            dispatch(pollingFailure('create', error))
          },
        })
      ),
    error => {
      dispatch(pollingFailure('create', error))
    }
  )
}

export const createDocumentGdrive = () => (dispatch, getState, { gapi }) => {
  gapi
    .openDocumentPicker()
    .then(data => Promise.resolve(data.docs[0]))
    .then(gdriveDocument => {
      const uploadStartTime = Date.now()

      dispatch(pollingBegin('create'))
      return gapi.downloadDocx(gdriveDocument.id).then(documentData =>
        dispatch(
          getSignedUrl({ name: documentData.filename }, { type: 'gdrive', parentId: gdriveDocument.parentId })
        ).then(uploadPolicy =>
          fetch(uploadPolicy.signedUrl, {
            method: 'PUT',
            body: documentData.file,
          }).then(() => dispatch(createDocument(uploadPolicy, uploadStartTime)))
        )
      )
    })
}

export const createDocumentText = text => dispatch => {
  dispatch(pollingBegin('create'))
  const uploadStartTime = Date.now()
  dispatch(getSignedUrl({ name: 'paper.txt' }, { type: 'paste' })).then(uploadPolicy =>
    fetch(uploadPolicy.signedUrl, { method: 'PUT', body: text }).then(() =>
      dispatch(createDocument(uploadPolicy, uploadStartTime))
    )
  )
}
